import { Component } from '@angular/core';

@Component({
  selector: 'app-cards7-examples-45',
  templateUrl: './cards7-examples-45.component.html'
})
export class Cards7Examples45Component {}
